import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, NgZone } from '@angular/core';
import { ApiService } from '../service/api.service.js';
import { AuthenticationService } from '../service/authentication.service.js';
import { UtilService } from '../service/util.service';
import { Constants } from '../constants/constants.js';
import { VehicleService } from '../service/vehicle.service.js';
import { isNullOrUndefined } from 'util';
import { EnrollmentConstants } from '../constants/enrollment-constants.js';
import { ToastService } from '../service/toast.service.js';

@Component({
  selector: 'app-view-vehicle-detail',
  templateUrl: './view-vehicle-detail.component.html',
  styleUrls: ['./view-vehicle-detail.component.scss']
})
export class ViewVehicleDetailComponent implements OnInit {
  @Input() vehicleData;
  @Input() showAccount: boolean = false;
  //@Input() isShowEditbtn = true;
  //@Output() submitEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeEmitter: EventEmitter<any> = new EventEmitter<any>();
  location: any = {};
  account: any = {};
  servicePackageList: any = [];

  vehicleDates: Array<any> = []
  deviceHistory: any;
  isDongleDevice: boolean;
  isShowTCUDeviceHistory: boolean;
  vehicleSummaryDate: any;

  constructor(private apiService: ApiService, public authService: AuthenticationService, public utilService: UtilService, private zone: NgZone, private vehicleService: VehicleService, private toastService: ToastService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.init();
  }

  init() {
    //this.servicePackageData = [];
    if (this.vehicleData && (!this.vehicleData.devices || this.vehicleData.devices.length == 0))
      this.vehicleData.devices = [];
    
    this.account = this.authService.accountData;
    this.initVehicleSummaryDate();
    this.initHistory();
    // this.initVehicleDates();
    console.log("121 Vehicle data : ", this.vehicleData);
    console.log("Account Data:", this.account);
    this.getVehiclesServicePackages(this.account.id, this.vehicleData.vin);
    // this.getVehiclesLocation(this.account.id, this.vehicleData.vin)
    //this.getVehiclesServicePackageLocationInfo(this.account.id, this.vehicleData.vin);
  }

  initVehicleSummaryDate() {
    this.vehicleSummaryDate = null;
    if (this.vehicleData.status == EnrollmentConstants.ACTIVE || this.vehicleData.enrollmentStatus == EnrollmentConstants.ENROLLED) {
      this.vehicleSummaryDate = {'key': EnrollmentConstants.ENROLLMENT_DATE, 'value': this.vehicleData.enrolledDate};
    } else if (this.vehicleData.status == EnrollmentConstants.ORDERED) {
      this.vehicleSummaryDate = {'key': EnrollmentConstants.ORDERED_DATE, 'value': this.vehicleData.orderedDate};
    } else if (this.vehicleData.status == EnrollmentConstants.DELIVERED) {
      this.vehicleSummaryDate = {'key': EnrollmentConstants.DELIVERY_DATE, 'value': this.vehicleData.deliveryDate};
    } else if (this.vehicleData.status == EnrollmentConstants.DELETED) {
      this.vehicleSummaryDate = {'key': EnrollmentConstants.DELETED_DATE, 'value': this.vehicleData.deletedDate};
    } else if (this.vehicleData.status == EnrollmentConstants.INACTIVE || this.vehicleData.status == EnrollmentConstants.ASSIGNED) {
      if(this.vehicleData.enrollmentStatus == EnrollmentConstants.UNENROLLED) {
        this.vehicleSummaryDate = {'key': EnrollmentConstants.UNENROLLMENT_DATE, 'value': this.vehicleData.unenrolledDate};
      } else {
        this.vehicleSummaryDate = {'key': EnrollmentConstants.DELIVERY_DATE, 'value': this.vehicleData.deliveryDate};
      }
    }
  }

  closeClicked() {
    this.closeEmitter.emit(JSON.parse(JSON.stringify(this.vehicleData)));
  }

  getVehiclesServicePackages(accountId: string, vin: string) {
    this.utilService.showSpinner();
    this.apiService.getVehiclesServicePackages(accountId, vin).then((data) => {
      this.utilService.hideSpinner();
      this.servicePackageList = data;
      console.log("ServicePackageList:", this.servicePackageList);
      // this.updateSelectedServicePackage();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getVehiclesServicePackages(accountId, vin);
        });
      }
      else {
        this.utilService.hideSpinner();
        // if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        // else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getVehiclesLocation(accountId: string, vin: string) {
    this.utilService.showSpinner();
    this.apiService.getVehiclesLocation(accountId, vin).then((data) => {
      this.utilService.hideSpinner();
      this.location = data;
      console.log("location:", this.location);
      // this.updateSelectedServicePackage();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getVehiclesLocation(accountId, vin);
        });
      }
      else {
        this.utilService.hideSpinner();
        // if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        // else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getVehiclesServicePackageLocationInfo(accountId, vin) {
    this.utilService.showSpinner();
    this.apiService.getVehiclesPackageLocationInfo(accountId, vin).subscribe(responseList => {
      this.zone.run(() => {
        console.log("responseList:", responseList);
        this.servicePackageList = responseList[0];
        this.location = responseList[1];
        console.log("ServicePkgs:", this.servicePackageList);
        console.log("Locations:", this.location);
        this.utilService.hideSpinner();
      });
      //this.responseData3 = responseList[1];
    });

  }

  getVehicleLogo(vehicle): string {
    return this.vehicleService.getVehicleLogo(vehicle);
  }

  // shu: don't remove, it may be required to revert to below code
  /* initVehicleDates() {
    var vehicleStateDateValue = ["orderedDate", "deliveryDate", "enrolledDate", "unenrolledDate"];
    var vehicleStatusDateKey = [EnrollmentConstants.ORDERED_DATE, EnrollmentConstants.DELIVERY_DATE, EnrollmentConstants.ENROLLMENT_DATE, EnrollmentConstants.UNENROLLMENT_DATE];

    this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[0], this.vehicleData[vehicleStateDateValue[0]]));

    if (this.vehicleData.status == EnrollmentConstants.DELIVERED || this.vehicleData.status == EnrollmentConstants.INACTIVE || this.vehicleData.status == EnrollmentConstants.ASSIGNED) {
      this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[1], this.vehicleData[vehicleStateDateValue[1]]));

      if (this.vehicleData.enrollmentStatus == EnrollmentConstants.UNENROLLED) {
        this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[2], this.vehicleData[vehicleStateDateValue[2]]));
        this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[3], this.vehicleData[vehicleStateDateValue[3]]));
      }
    }
    else if (this.vehicleData.status == EnrollmentConstants.ACTIVE) {
      this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[1], this.vehicleData[vehicleStateDateValue[1]]));
      this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[2], this.vehicleData[vehicleStateDateValue[2]]));
    }
  } */
  initVehicleDates() {
    this.setVehicleDates(0);

    if (this.vehicleData.status == EnrollmentConstants.DELIVERED || this.vehicleData.status == EnrollmentConstants.INACTIVE || this.vehicleData.status == EnrollmentConstants.ASSIGNED) {
      this.setVehicleDates(1);
      if (this.vehicleData.enrollmentStatus == EnrollmentConstants.UNENROLLED) {
        this.setVehicleDates(2);
        this.setVehicleDates(3);
      }
    }
    else if (this.vehicleData.status == EnrollmentConstants.ACTIVE) {
      this.setVehicleDates(1);
      this.setVehicleDates(2);
    }

    if (this.vehicleData.status == EnrollmentConstants.DELETED) {
      this.setVehicleDates(1);
      this.setVehicleDates(2);
      this.setVehicleDates(3);
      this.setVehicleDates(4);
    }

  }

  setVehicleDates(index) {
    var vehicleStateDateValue = ["orderedDate", "deliveryDate", "enrolledDate", "unenrolledDate"];
    var vehicleStatusDateKey = [EnrollmentConstants.ORDERED_DATE, EnrollmentConstants.DELIVERY_DATE, EnrollmentConstants.ENROLLMENT_DATE, EnrollmentConstants.UNENROLLMENT_DATE];
    if (this.vehicleData[vehicleStateDateValue[index]]) {
      this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[index], this.vehicleData[vehicleStateDateValue[index]]))
    }
  }

  getVehicleHistoryObject(key: string, value: any) {
    var vehicleHistory = { 'key': key, 'value': '' };
    if (!isNullOrUndefined(value)) {
      vehicleHistory.value = value;
    }
    return vehicleHistory;
  }

  initHistory() {
    let dongleDevices = this.vehicleData && this.vehicleData.devices && this.vehicleData.devices.length ? this.vehicleData.devices.filter(device => device.telematicsProvider == "CONTINENTAL") : [];
    if (this.vehicleData && ((this.vehicleData.deviceStatus && dongleDevices.length > 0) || this.vehicleData.deviceStatus == 'UNLINKED')) {
      this.isShowTCUDeviceHistory = false;
      if (dongleDevices.length > 0) {
        this.getDeviceHistory(dongleDevices[0].id, this.vehicleData.vin);
      }
      // TODO: unlinked vehicle history
      /* else {
        this.getDeviceHistory(this.vehicleData.vin);
      } */
    } else {
      this.isShowTCUDeviceHistory = true;
      this.initVehicleDates();
    }
  }

  getDeviceHistory(deviceId, deviceVin?) {
    this.utilService.showSpinner();
    this.apiService.getDeviceHistory(deviceId, deviceVin).then((data) => {
      this.utilService.hideSpinner();
      console.log("device history response::", data);
      this.deviceHistory = data;
      if (this.deviceHistory) {
        this.initDeviceDates(this.deviceHistory.statusHistory);
      } else {
        this.initDeviceDates(null);
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getDeviceHistory(deviceId, deviceVin);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  /* initDeviceDates(statusHistory) {
    if (statusHistory && statusHistory.length > 0) {
      for (let i = 0; i < statusHistory.length; i++) {
        this.vehicleDates.push(this.getVehicleHistoryObject(Constants.STATUS_NAME_MAP.get(statusHistory[i].status), statusHistory[i].date));
      }
    } else {
      this.vehicleDates = [];
    }

  } */
  initDeviceDates(statusHistory) {
    this.vehicleDates = [];
    if (statusHistory && statusHistory.length > 0) {
      for (let i = 0; i < statusHistory.length; i++) {
        this.vehicleDates.push(this.getVehicleHistoryObject(Constants.STATUS_NAME_MAP.get(statusHistory[i].status), statusHistory[i].date));
      }
    }

  }

  vehicleDataUpdated(event) {
    this.vehicleData = event;
    this.initHistory();
  }

  // NATODO: Copy this in vehicle detail page and change in html
  showVehicleDeviceStatus() {
    if(this.utilService.doesAccountSupportsDongle(this.account.category)){
      if (!this.vehicleData.deviceStatus || (this.vehicleData.deviceStatus == 'NONE' || this.vehicleData.deviceStatus == 'UNLINKED')) {
        return false;
      }

      return true;
    }
    return false;
  }

  doesAccountSupportsDongle() {
    if (this.utilService.doesAccountSupportsDongle(this.account.category)) {
      return true;
    }
    return false;
  }
}
